import * as React from "react";
import { useMemo } from "react";
import { defaultCompare } from "logic/DefaultCompare";
import Select from "components/common/Select";
const ColumnSelect = ({
  ariaLabel = void 0,
  autoFocus = void 0,
  allowCreate = false,
  className = void 0,
  clearable = false,
  columns,
  columnTitle,
  id,
  excludedColumns = [],
  name,
  onChange,
  onMenuClose = void 0,
  openMenuOnFocus = void 0,
  persistSelection = void 0,
  placeholder = void 0,
  selectRef = void 0,
  value
}) => {
  const columnOptions = useMemo(
    () => columns.filter((column) => !excludedColumns.includes(column)).map((column) => ({
      value: column,
      label: columnTitle(column)
    })).sort(({ label: label1 }, { label: label2 }) => defaultCompare(label1, label2)),
    [columnTitle, columns, excludedColumns]
  );
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      options: columnOptions,
      inputId: `select-${id}`,
      forwardedRef: selectRef,
      allowCreate,
      className,
      onMenuClose,
      openMenuOnFocus,
      persistSelection,
      clearable,
      placeholder,
      name,
      size: "small",
      value,
      "aria-label": ariaLabel,
      autoFocus,
      onChange
    }
  );
};
export default ColumnSelect;
